import TRANSLATIONS from './json/en_AU_translations.json'

const TRANSLATIONS_EN_AU = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Hover to Zoom',
  'shopping_cart_details.tapToZoom': 'Tap to Zoom',
  'coupon_code.page_link': 'national-pen-promo-codes',
  'order_summary.your_promos' : 'Your Promos',
  'shopping_cart_details.editImprint': 'Edit Imprint',
  'shopping_cart_details.clickToZoom': 'Click to Zoom',
  'shopping_cart_details.ships_within_msg': 'Ships within [X] business days',
  'shopping_cart_details.item_total': 'Item Total:',
  'shopping_cart_details.each': '[X] each',
  'shopping_cart_details.see_more' : 'See More',
  'shopping_cart_details.see_less' : 'See Less',
  'order_confirmation.cartToOrderFailureMessage' : 'Your order will be confirmed shortly.',
  'checkout_payment.paymentErrorTitle': 'Payment Error',
  'checkout_payment.paymentErrorMessage': 'Please try re-entering your payment details. If the issue persists, contact our Customer Care Team for assistance.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Credit/Debit',
  'checkout_payment.card_number': 'Card Number*',
  'checkout_payment.expiration_mm_yy': 'MM/YY*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Name on Card*',
  'checkout_payment.check_cc_try_again': 'Please check the card number, and try again.',
  'checkout_payment.check_date_try_again': 'Please check the date, and try again.',
  'checkout_payment.check_code_try_again': 'Please check the code, and try again.',
  'checkout_payment.enter_holder_name': 'Enter the name on your card.',
  'checkout_payment.enter_cc_number': 'Enter the card number.',
  'checkout_payment.enter_expiration_date': 'Enter the expiry date.',
  'checkout_payment.enter_cvv': 'Enter the security code.',
  'checkout_payment.paypal_pay_later': 'PayPal Pay Later',
  'checkout_payment.continue_will_open_paypal_account_msg': 'Continuing will take you to your PayPal account.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'Continuing will take you to Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Pay By Invoice',
  'checkout_payment.buy_now_pay_later_info_msg': 'Buy now and pay later! We’ll send you an invoice once your order is on the way.',
  'checkout_payment.learn_more': 'Learn More',
  'checkout_payment.payment_due_late_fee_info_msg': 'Payment is due upon the receipt of your invoice. Late payments may incur fees.',
  'shopping_cart_details.unit': 'unit',
  'shopping_cart_details.editModalSaving': `You're saving`,
  'shopping_cart_details.editModalMin_QtyWarning': `Sorry, that is below our minimum quantity. To place a smaller order, please contact us at 1-866-900-7367.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Sorry, that exceeds our maximum quantity. To place a larger order, please contact us at 1-866-900-7367.`,
  'product_details.price':'Price',
  'product_details.edit_quantity':'Edit quantity',
  'myaccount_order_details.seeDetails': 'See Details',
  'myaccount_order_details.viewOrderDetails': 'View Order Details',
  'myaccount_order_details.payMyInvoice': 'Pay My Invoice',
  'myaccount_order_details.buyItAgain': 'Buy It Again',
  'myaccount_order_details.viewImprint': 'View Imprint',
  'myaccount_order_details.viewArtwork': 'View Artwork',
  'myaccount_order_details.productDetails': 'Product Details',
  'myaccount_order_details.orders': 'orders',
  'my_account_order_details.shipping_and_billing_addresses': 'Shipping and Billing Addresses',
  'my_account_order_details.log_in_to_view' : 'Log In to View',
  'error.use_of_old_password': 'Password must be different from your previous five passwords.',
  'order_confirmation.postCheckout_signIn':`Sign In for More Benefits`,
  'order_confirmation.postCheckout_accountCreation':'Sign Up for More Benefits',
  'order_confirmation.postCheckout_trackOrder':'Track Your Order with Ease',
  'order_confirmation.would_you_like_to':'Get special savings and free samples when you sign up for email and phone offers from Pens.com!',
  'order_confirmation.sign_up.contact_agreement1':'Yes',
  'order_confirmation.sign_up.contact_agreement2':', I love deals!',
  'order_confirmation.sign_up.contact_disagreement1':'No',
  'order_confirmation.sign_up.contact_disagreement2':', thank you',
  'create_account.title':'Create Your Account',
  'order_confirmation.sign_in.title':'Log In to Your Account',
  'order_confirmation.my_acc.title':'My Account',
  'order_confirmation.addPassword':'Just add a password:',
  'order_confirmation.accountCreated':'Account Created',
  'myaccount_address_list.shippingAddresses': 'Shipping Addresses',
  'myaccount_address_list.billingAddresses': 'Billing Addresses',
  'myaccount_address_list.defaultAddress': 'Default Address',
  'myaccount_address_list.setDefault': 'Set Default',
  'myaccount_delete_address.delete_confirmation': 'Delete confirmation',
  'myaccount_delete_address.confirmation_message': 'Are you sure you want to delete this address?',
  'myaccount_delete_address.delete_address': 'Delete address',
  'myaccount_delete_address.delete': 'Delete',
  'myaccount_error_new_password.complexity':"New password must include: a number, special character [!#$%&'*+-/=?^_`{|}~.@], uppercase and lowercase letters.",
  'myaccount_error_confirm_password.complexity':"Confirmed password must include: a number, special character [!#$%&'*+-/=?^_`{|}~.@], uppercase and lowercase letters.",
  'myaccount_error_new_password.common_password':'New password cannot be the same as your email address.',
  'myaccount_error_confirm_password.common_password':'Confirmed password cannot be the same as your email address.',
  'myaccount.change_personal_information.change_password_info' : 'All active devices will be signed out.',
  'validation.password_validation_heading' : 'Password must include:',
  'validation.password_validation_uppercase' : 'An uppercase character',
  'validation.password_validation_lowercase' : 'A lowercase character',
  'validation.password_validation_symbol' : 'A special character',
  'validation.password_validation_number' : 'A number',
  'validation.password_validation_length' : 'At least 8 characters',
  'validation.password_validation_match' : 'Passwords must match',
  'validation.password_min_characters': 'Password must be at least 8 characters long.',
  'myaccount_password_settings.heading' : 'Password Settings',
  'myaccount_password_settings.newPassword' : 'New Password',
  'myaccount_password_settings.confirmPassword' : 'Confirm Password',
  'myaccount_password_settings.updatePassword' : 'Update Password',
  'myaccount_password_settings.createPassword' : 'Create Password',
  'myaccount_password_settings.use_of_old_password': 'Password must be different from your previous five passwords.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'shopping_bag.expired_discount_coupon':'The promo code you have entered has expired. Please enter a different promo code.',
  'shopping_bag.invalid_discount_coupon':'The promo code you have entered is not valid. Please enter a different promo code.',
  'order_summary.oops_error': 'Oops! It seems that something went wrong on our end! Please try again.',
  'order_summary.one_promo_at_a_time': 'Only one promo code can be applied at a time.',
  'order_summary.code_applied': 'Code Applied',
  'order_summary.change_promo': 'Change Promo Code',
  'order_summary.your_promo_code': 'Your Promo Codes',
  'order_summary.no_items_eligible': 'No items in your cart are eligible for this promo code.',
  'order_details.production_time_begin_msg': '*Production time begins once the order is confirmed and any artwork is approved',
  'order_details.reorder_tat': 'Reorders ship in X business days*',
  'dashboard.edit' : 'Edit',
  'dashboard.greeting':'Hi There!',
  'myaccount_personal_info.save_changes' : 'Save Changes',
  'myaccount_personal_info.cancel' : 'Cancel',
  'myaccount_personal_info.name_title' : 'Name',
  'myaccount_personal_info.password_title' : 'Password',
  'myaccount_personal_info.add_name' : 'Add Name',
  'myaccount_personal_info.edit_name' : 'Edit Name',
  'myaccount_personal_info.name_updated' : 'Name Updated.',
  'myaccount.something_went_wrong': 'Something went wrong. Please try again.',
  'checkout.reorder.buy_it_again':'Buy It Again',
  'checkout.reorder.purchased':'Purchased',
  'checkout.reorder.last_qty':'Last Ordered quantity',
  'checkout.reorder.ships_within_msg':'Ships within [X] business days',
  'checkout.reorder.add_to_cart': 'Add to Cart',
  'shopping_cart_details.add_accessory': 'Add an Accessory',
  'oos.item_out_of_stock': 'This item is currently out of stock.',
  'oos.view_similar': 'View Similar Products',
  'oos.similar_products': 'Similar Products',
  'oos.remove_out_of_stock_items': 'Sorry, you will need to remove out of stock items from your cart.',
  'oos.one_or_more_items_removed_from_cart': 'One or more sizes are out of stock and have been removed from this item.',
  'oos.go_back_to_review': 'Go Back to Cart to Review',
  'oos.go_back_to_remove': 'Go Back to Cart to Remove Item',
  'oos.out_of_stock': 'Out of Stock',
  'pcc.buy_now_customize_later': 'Buy Now, Customize Later',
  'shopping_cart_details.add_amount': 'Add [X] to unlock offer',
  'import_charge_title':'Tariff Fee',
  'import_charge_description':'Recent tariff fees have affected the pricing of our products. We are working to mitigate the impact of price increases on our customers.',
  'gdpr.heading' : 'Account Created, Welcome!',
  'gdpr.subheading' : 'Your account has been created using your email address:',
  'gdpr.promotion': 'Get special savings and free samples when you subscribe to email offers from Pens.com!',
  'gdpr.yesDeal' : 'Yes, I love a deal',
  'gdpr.noDeal' : 'No, thank you',
  'gdpr.button' : 'Continue',
  'new_activation.head' : 'Check Your Email!',
  'new_activation.sub_head' : 'Hi There',
  'new_activation.main_body1' : 'Thank you for joining Pens.com',
  'new_activation.main_body2' : 'An activation link will be sent to your registered email address',
  'new_activation.main_body3' : 'You will not be able to sign in until your account has been activated. Please click the activation link to activate your account.',
  'myaccount_personal_info.password_not_set' : 'A password has not been set for this account. Please',
  'myaccount_personal_info.click_here' : 'click here',
  'myaccount_personal_info.to_reset_password' : 'to create a new password.',
  'myaccount_personal_info.note' : 'Note: This action will log you out of all active sessions.',
  'moq.lineItem_warning': 'Your order is below the minimum order quantity for this item.',
  'moq.edit_qantity_link_text': 'Please select a new order quantity.',
  'moq.cart_level_warning': 'Please update your order quantity to check out.',
  'moq.go_back_to_cart': 'Go Back to Cart to Select New Order Quantity',
  ...TRANSLATIONS
};
export default TRANSLATIONS_EN_AU;